import { Link } from 'react-router-dom';
import { ROUTES } from '@/shared/config/routes';
import { Seo } from '@/shared/seo';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md px-6 py-24 text-center">
      {/*
        Cloudflare's SPA fallback serves this with HTTP 200, so search engines
        would otherwise treat every typo'd URL as a real, indexable page.
      */}
      <Seo title="Page not found" noIndex />
      <p className="font-display text-6xl font-black italic text-amber-500">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold text-foreground">Page not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">That page doesn’t exist or has moved.</p>
      <Link
        to={ROUTES.home}
        className="mt-6 inline-block rounded-full bg-amber-400 px-5 py-2.5 text-sm font-bold text-zinc-950 transition-all hover:bg-amber-300"
      >
        Back to articles
      </Link>
    </div>
  );
}
